export default "__VITE_ASSET__11748819__"